import React, { useContext, useMemo, useState } from "react";
import StatisticsGrid from "../overview/statisticsGrid";
import OrganizationOverview from "../overview/orgOverview";
import { OrganizationInfo } from "../../../../../types/organization";
import { CorporationOperation } from "../../../../../serviceoperation/CorporationOperation";
import { AuthenticationContext } from "../../../../../contexts/authentication-context";
import { CompanyContext } from "../../../../../contexts/company-context";
import {
  CorpDetailAPIEntity,
  CorporationStatsEntity,
} from "../../../../../serviceoperation/entity/CorporationOperationEntity";

export const mockOrganization: OrganizationInfo = {
  id: "1",
  name: "TechCorp Solutions",
  industry: "Technology",
  foundedYear: 2010,
  headquarters: "San Francisco, CA",
  website: "www.techcorp.com",
  stats: {
    totalEmployees: 250,
    totalLocations: 5,
    totalDepartments: 12,
    activeProjects: 28,
  },
};

const OverviewTab: React.FC = () => {
  const userInfo = useContext(AuthenticationContext)?.userInfo;
  const { selectedCompany } = useContext(CompanyContext);
  const [corpProfile, setCorpProfile] = useState<CorpDetailAPIEntity>();
  const [corpStat, setCorpStats] = useState<CorporationStatsEntity>();
  const [loading, setLoading] = useState<boolean>(true);

  useMemo(() => {
    const corpOps = new CorporationOperation();
    corpOps
      .getCorpByIdAsync(selectedCompany?.corporationId as number)
      .then((x) => {
        setCorpProfile(x.data!);
        setLoading(false);
      });
    corpOps
      .getCorpStatsByIdAsync(selectedCompany?.corporationId as number)
      .then((x) => {
        setCorpStats(x.data!);
      });
  }, [selectedCompany, userInfo]);

  return (
    <div style={{ margin: "16px" }}>
      <OrganizationOverview organization={corpProfile} loading={loading} />
      <StatisticsGrid stats={corpStat} loading={loading} />
    </div>
  );
};

export default OverviewTab;
